import { FieldDesignChangeStatus } from 'shared'
import { useFDCTrackerContext } from '../../../../../FDCTrackerContext'
import { FieldDesignChange } from '../../../../../FDCTrackerContext/types'
import { Button } from 'antd'

const Status: React.FC<FieldDesignChange> = (record) => {
  const { statusId, deleted } = record
  const {
    mutations: { submit },
  } = useFDCTrackerContext()
  const { name } = FieldDesignChangeStatus.fromIdOrFail(statusId)
  if (statusId !== FieldDesignChangeStatus.Draft.id) return <>{name}</>
  if (!submit.can) return <>{name}</>
  return (
    <Button
      disabled={deleted}
      type="link"
      style={{ whiteSpace: 'normal', padding: 0, display: 'inline-flex' }}
      onClick={() => submit.toggle(record)}
    >
      {name}
    </Button>
  )
}

export default Status
